(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/marionette/commands.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/marionette/commands.js');

(function(Backbone, _, svs) {
  'use strict';

  var clientName = 'nyxclient';

  function renderLoggedInTime(el, timeInMinutes) {
    var timeToDisplay;
    if (timeInMinutes < 60) {
      timeToDisplay = timeInMinutes + ' min';
    } else if (timeInMinutes < 24 * 60) {
      timeToDisplay =
        Math.floor(timeInMinutes / 60) +
        ' tim ' +
        (timeInMinutes % 60) +
        ' min';
    } else if (timeInMinutes < 48 * 60) {
      timeToDisplay = '1 dag';
    } else {
      timeToDisplay = Math.ceil(timeInMinutes / (24 * 60)) + ' dagar';
    }
    el.html('Inloggad tid: ' + timeToDisplay);
  }

  svs.bingo.nyxChannel.reply('initBingoClient', function(gameParams) {
    window.NyxClientInterface =
      window.NyxClientInterface ||
      new svs.bingo.NyxClientInterfaceClass(clientName);
    window.NyxClientInterface.init();
    var settingspath;
    var assetspath;
    var nyxbingoclient;
    var flashvars;
    var params;
    var wagerId;
    var bingoAssets = svs.bingo.data.htmlAssets;
    var userSession =
        svs.bingo.data &&
        svs.bingo.data.session &&
        svs.bingo.data.session.pamSessionId;

    $(window).scrollTop(0);
    $('.js-bingo-show-gameguide').on('click', function() {
      svs.bingo.nyxChannel.request('showSpelguide');
    });

    params = {};
    params.base =
      svs.core.config.data.svsconfig.cdn2 +
      '/nyx/bingoclient/' +
      bingoAssets.folder_name +
      '/bingo/';
    params.scale = 'noScale';
    params.menu = 'false';
    params.wmode = 'opaque';
    params.allowscriptaccess = 'always';

    flashvars = {
      nyxroot: svs.core.jupiter.url().split('//')[1] + '/proxy',
      secure: 'yes',
      xmlconfigpath: '../../nyxconf/bingo/'
    };

    if (gameParams.gameId) {
      flashvars.gameid = gameParams.gameId;
    }

    if (gameParams.wagerId) {
      flashvars.ref = gameParams.wagerId.toString();
    }

    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      flashvars.waitfor = 'DO_LOGIN';
    }

    var clientVersion = svs.bingo.data.clientVersion;

    if (svs.core.detect.feature('ft-bingo-versions') && clientVersion) {
      settingspath = svs.core.config.data.svsconfig.cdn2 + '/nyxbingo/' + clientVersion + '/htmlbingoclient/nyxconf/settings.json';
      assetspath = svs.core.config.data.svsconfig.cdn2 + '/nyxbingo/' + clientVersion + '/htmlbingoassets';
    } else {
      settingspath = svs.core.config.data.svsconfig.cdn2 + '/nyxbingo/htmlbingoclient/nyxconf/settings.json';
      assetspath = svs.core.config.data.svsconfig.cdn2 + '/nyxbingo/htmlbingoassets';
    }

    if (gameParams.wagerId) {
      wagerId = gameParams.wagerId;
    } else {
      wagerId = null;
    }

    setTimeout(function() {
      var sessionTimeContainers = $('.js-bar-session-time');
      var clientHeight;
      var topBarHeight = $('.bingo-top-bar').outerHeight();
      if (sessionTimeContainers.length > 0) {
        var bottomBarSessionTimeHeight = 30;
        clientHeight =
          window.innerHeight -
          svs.components.header.getTopContentWrapperHeight() -
          bottomBarSessionTimeHeight;
        svs.events.subscribe('/components/session_time/sessionTimeM', function(sessionTime) {
          renderLoggedInTime(sessionTimeContainers, sessionTime);
        });
        renderLoggedInTime(
          sessionTimeContainers,
          svs.components.session_time.get()
        );
      } else {
        clientHeight =
          window.innerHeight -
          topBarHeight -
          svs.components.header.getTopContentWrapperHeight();
      }

      $('#nyxclient').css('height', clientHeight);

      nyxbingoclient = new window.NYXBINGO.NyxClient(document.getElementById('nyxclient'));
      window.nyxbingoclient = nyxbingoclient;
      nyxbingoclient.run({
        skinname: 'Default',
        messageSequences: window.NYXBINGO.MessageSequences,
        language: 'sv',
        culture: 'US',
        settingsPath: settingspath,
        operator: 'SvSpel',
        partner: 'SvSpel',
        wagerId: wagerId,
        session: userSession,
        gameId: gameParams.gameId,
        operatorAssetRoot: assetspath,
        nyxroot: svs.core.jupiter.url() + '/proxy',
        optionalNoCacheLoadParam:
          (svs.bingo.data.htmlBingoAssetsVer &&
            svs.bingo.data.htmlBingoAssetsVer.assets_ver) ||
          'noVerNum'
      });
      svs.bingo.nyxChannel.request('attachBingoCallback');
    }, 100);
  });

  svs.bingo.nyxChannel.reply('loadGame', function(wagerId) {
    window.NyxClientInterface =
      window.NyxClientInterface ||
      new svs.bingo.NyxClientInterfaceClass(clientName);
    window.NyxClientInterface.loadGame(wagerId);
    svs.components.headerslidedownmenu.hide();
  });

  svs.bingo.nyxChannel.reply('destroyClient', function() {
    window.NyxClientInterface && window.NyxClientInterface.destroy();
    window.NyxClientInterface = undefined;
  });

  svs.bingo.nyxChannel.reply('sendStatistics', function(gameData) {
    var items = [];
    var extraData;
    var trackingItem;

    extraData = {
      gameType: gameData.gameName
    };

    trackingItem = new svs.components.analytics.transactionItem(
      gameData.gameId, 
      'Bingo', 
      gameData.betAmount,
      1,
      extraData
    );
    items.push(trackingItem);

    var transaction = new svs.components.analytics.transaction(
      gameData.wagerId,
      gameData.betAmount,
      items,
      0,
      0
    );

    svs.components.analytics.trackTransaction(transaction);
  });
  svs.bingo.nyxChannel.reply('showSpelguide', function(tab) {
    svs.components.Modal.show(
      svs.bingo.views.Spelguide,
      {
        selectedTab: tab
      },
      {
        title: 'Spelguide',
        headerClass: 'header-bingo',
        leftButton: {
          text: 'Stäng',
          visible: true,
          cssClass: 'btn-transparent-default'
        },
        rightButton: { visible: false },
        doubleWidth: !svs.core.detect.formfactor.mobile()
      }
    );
  });

  svs.bingo.nyxChannel.reply('resetHeader', function() {
    if (!svs.core.detect.formfactor.mobile()) {
      svs.core.template.updateConfig({
        title: {
          row1: {
            brand: 'bingo',
            alt: 'Bingo'
          }
        }
      });
    }
  });

  svs.bingo.nyxChannel.reply('hideBackground', function() {
    $('.js-bingo-background').addClass('bingo-background-hide');
  });
})(Backbone, _, svs);


 })(window);